import React from "react";
import { useNavigate } from "react-router-dom";
import "./ManaGuideOverlay.css";

interface Props {
  onClose?: () => void;
}

export function ManaGuideOverlay({ onClose }: Props): JSX.Element | null {
  const navigate = useNavigate();

  const handleClickMana = () => {
    onClose?.();
    navigate("/mana");
  };

  return (
    <div className="mana-guide" aria-hidden={false}>
      <div
        className="mana-guide__overlay"
        onClick={(e) => e.preventDefault()}
      />
      <button
        type="button"
        className="mana-guide__hotspot"
        aria-label="Open Mana"
        onClick={handleClickMana}
      />
      <div className="mana-guide__arrow" aria-hidden="true" />
    </div>
  );
}
